import styled from 'styled-components'

import { StyledComponentWithCompound } from 'shared/types/global'
import Flex from 'shared/ui/Flex'

export const Section: StyledComponentWithCompound = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-right: 24px;
  width: 100%;
`

export const Heading = styled(Flex)`
  flex-direction: column;
  gap: 4px;
`

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: ${({ theme }) => theme.color.base.c9};
`

export const Description = styled.span`
  font-size: 12px;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.color.base.c8};
`

Section.Heading = Heading
Section.Title = Title
Section.Description = Description
Section.Content = styled.div``

export const CustomCoverSettingsWrapper = styled(Flex)`
  position: relative;
  flex-direction: column;
  gap: 32px;
`

export const Cover = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 16px;
`
